import * as React from 'react'
import MaskedInput from 'react-text-mask'

const CustomMaskedInput = (mask: Array<string | RegExp>) =>
  React.forwardRef((props: any, ref) => {
    // Remove inputRef from props that MUI passes to avoid it leaking to DOM
    const { inputRef, ...otherProps } = props

    // Create a wrapper function that gets called by react-text-mask
    // and forwards it to both the forwarded ref (for MUI) and handles the input element
    const handleRef = React.useCallback(
      (inputElement: HTMLInputElement | null) => {
        // Forward to MUI's ref
        if (typeof ref === 'function') {
          ref(inputElement)
        } else if (ref) {
          ;(ref as React.MutableRefObject<HTMLInputElement | null>).current = inputElement
        }
      },
      [ref]
    )

    return <MaskedInput {...otherProps} inputRef={handleRef} guide={false} mask={mask} />
  })
export default CustomMaskedInput
